import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function ElConsul() {
  return <NeighborhoodPageContent slug="el-consul" />;
}